import { emailElementType } from "../constants/emailElementType.constants";
import { elementHandlers } from "../elements/elementHandlers";
import { defaultEmailElement } from "../models/defaultEmailElement";
import { deepClone, setValueToNestedObject } from "../../../../helpers/objectHelper";
import { templateHelper } from "../../template/helpers/templateHelper";
import { createTagDictionaryForReplace } from "../../tags/models/tagDictionary";

export const emailHelper = {
  getElementHandler,
  sortElementOnChange,
  sortElements,
  createElement,
  renderElement,
  handleTemplateStyleInheritage,
  replaceTextTags,
  incrementList,
};

/* const CodeReplace = (code, element) => {
    element.content = code;
} */
function renderElement(element) {
  const handler = getElementHandler(element.type);
  if (!handler || element.content === undefined) return null;
  return handler.component(element);
}
function handleTemplateStyleInheritage(elements, template) {
  const newElements = [];
  let templateCopy = deepClone(template);

  elements.map((el) => {
    let elementCopy = deepClone(el);
    if (el.style.inheritedStyles && el.style.inheritedStyles.length > 0) {
      el.style.inheritedStyles.map((its) => {
        const styleParts = its.stylePath ? its.stylePath.split(".") : "";
        const templateParts = its.templatePath ? its.templatePath.split(".") : "";

        let unit = templateHelper.getUnit(templateCopy, templateParts);
        let value = templateHelper.getValueWithoutUnit(templateCopy, templateParts);

        if (parseInt(value) && unit.length < 4) {
          value += unit;
        }

        elementCopy.style = setValueToNestedObject(styleParts, value, elementCopy.style);
      });
    }
    newElements.push(elementCopy);
  });
  return newElements;
}

function replaceTextTags(elements, reversed = false) {
  const parsedElements = Array.from(elements);
  const tags = createTagDictionaryForReplace();

  parsedElements.map((pe) => {
    if (pe.type === emailElementType.TEXT || pe.type === emailElementType.CALENDAR_INVITATION || (pe.families.length > 0 && pe.families.includes("text"))) {
      let text = pe.style.elementProps.text;
      if (text.length > 0) {
        tags.map((t) => {
          if (reversed) {
            if (text.includes(t.tag)) {
              text = text.replace(t.tag, t.editFacade);
            }
          } else {
            if (text.includes(t.editFacade)) {
              text = text.replace(t.editFacade, t.tag);
            }
          }
        });
      }
      pe.style.elementProps.text = text;
      let handler = getElementHandler(pe.type);
      pe.content = handler.elementEditor(pe.style);
    }
  });
  return parsedElements;
}

function getElementHandler(type) {
  switch (type) {
    case emailElementType.LARGE_HEADER_IMAGE:
      return elementHandlers.largeHeaderImageHandler;
    case emailElementType.SMALL_HEADER_IMAGE:
      return elementHandlers.smallHeaderImageHandler;
    case emailElementType.TEXT:
      return elementHandlers.textAreaHandler;
    case emailElementType.BUTTON:
      return elementHandlers.simpleButtonHandler;
    case emailElementType.SPACE:
      return elementHandlers.emptySpaceHandler;
    case emailElementType.BACKDROPIMAGE_ELEVATED_TEXT:
      return elementHandlers.backgroundWithImageHandler;
    case emailElementType.CALENDAR_INVITATION:
      return elementHandlers.calendarInvitationHandler;
    default:
      return null;
  }
}
function getNewId(elements) {
  if (elements.length < 1) return 1;
  const maxId = Math.max.apply(
    Math,
    elements.map(function (o) {
      return o.id;
    })
  );
  return maxId + 1;
}

function createElement(type, elements, destination, template = null) {
  const newElement = deepClone(defaultEmailElement);
  const handler = getElementHandler(type);

  if (!handler) return;

  const style = handler.defaultStyle(template, false);
  const content = handler.elementEditor(style, template, false);
  const newId = getNewId(elements);

  newElement.families = handler.families();
  newElement.style = style;
  newElement.content = content;
  newElement.id = newId;
  newElement.type = type;
  newElement.startTag = handler.tags().startTag;
  newElement.endTag = handler.tags().endTag;
  newElement.sortOrder = destination.index;
  return newElement;
}

//Sorters

function sortController(elements) {
  const controlledList = Array.from(elements);
  for (let index = 0; index < controlledList.length; index++) {
    if (controlledList[index].sortOrder !== index) {
      controlledList[index].sortOrder = index;
    }
  }
  return controlledList;
}

function sortElementOnChange(elements, sourceElement, destination, source) {
  if (destination.index > source.index) {
    //if moved down
    elements.map((el) => {
      if (el.sortOrder > source.index && el.sortOrder <= destination.index) {
        el.sortOrder -= 1;
      }
      if (el.id === sourceElement.id) {
        el.sortOrder = destination.index;
      }
    });
  } else if (destination.index < source.index) {
    elements.map((el) => {
      if (el.sortOrder <= source.index && el.sortOrder >= destination.index) {
        el.sortOrder += 1;
      }
      if (el.id === sourceElement.id) {
        el.sortOrder = destination.index;
      }
    });
  }
  return elements;
}
function incrementList(elements, destination) {
  let sortedElements = Array.from(elements);
  sortedElements.map((el) => {
    if (el.sortOrder >= destination.index) {
      el.sortOrder += 1;
    }
  });
  return sortedElements;
}

function sortElements(elements, destination = null, replaceTags = false) {
  if (!elements || !Array.isArray(elements)) return [];
  if (elements.length === 0) return elements;
  let sortedElements = Array.from(elements);
  if (destination) {
    sortedElements.map((el) => {
      if (el.sortOrder >= destination.index) {
        el.sortOrder += 1;
      }
    });
  }
  sortedElements = sortedElements.sort((a, b) => {
    let x = a.sortOrder;
    let y = b.sortOrder;
    return y < x ? 1 : y > x ? -1 : 0;
  });
  if (replaceTags == true) sortedElements = replaceTextTags(sortedElements, true);
  return sortController(sortedElements);
}
